import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CropAid } from 'src/app/crop-aid/crop-aid.model';
import { Environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CropAidApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/';

  getGenericCropAids(): Observable<CropAid[]> {
    return this.http
      .get<{ cropAids: CropAid[] }>(`${this.baseUrl}crop-aid`)
      .pipe(map(({ cropAids }) => cropAids));
  }

  getProprietaryCropAids(cropYear: number): Observable<CropAid[]> {
    return this.http
      .get<{ cropAids: CropAid[] }>(`${this.baseUrl}crop-aid/proprietary/${cropYear}/andolder`)
      .pipe(map(({ cropAids }) => cropAids));
  }
}
